import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const GET_CONTACTS = createAsyncActionTypes('GET_CONTACTS');